import React,{useState,useEffect} from 'react';
import AverageMonthlyData from './AvrgMonthlyData';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import api from '../../../Services/api';
import { Link } from "react-router-dom";

 
export default function Index() {
   let data = sessionStorage.getItem('user');
    let assessorData = JSON.parse(data);
    let id = assessorData.id;
  
    const [vendors, setVendors] = useState([]);
 const[loading,setLoading] = useState(true);
 const [snackbarOpen, setSnackbarOpen] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');


  
    const fetchData = async () => {
      try {
        const response = await api.vendor.getVendors(id);
        if(response.status === 200){
        setVendors(response.data.data);
        setLoading(false);
     
      }
      else if(response.status === 400){
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setVendors([])
        setLoading(false);
    }
    else if(response.status === 404){
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setVendors([])
        setLoading(false);
    }
    else if(response.status === 500){
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setVendors([])
        setLoading(false);
    }
    else{
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Some error occured, please try again")
        setVendors([])
        setLoading(false);
    }
  
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  
    useEffect(() => {
      const timer = setTimeout(()=>{
      fetchData();
      },600)
      return ()=> clearTimeout(timer)
    }, [id]);
  return (
    <div>
        <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
      
              }}
              severity="success"
              open={snackbarOpen}
              autoHideDuration={3000}
              onClose={() => setSnackbarOpen(false)}
              sx={{
                marginTop: '2.9%',
                marginRight: '7%'
              }}
            >
              <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              severity="error"
              open={errorSnackbarOpen}
              autoHideDuration={3000}
              sx={{
                marginTop: '2.9%',
                marginRight: '7%'
              }}
              onClose={() => { setErrorSnackbarOpen(false) }}
            >
              <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
            </Snackbar>
            {loading ? (
               <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
               <h3>Loading</h3>
      <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div> 
      <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
      <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
      
      </div>
            ) : (
            vendors && vendors.length > 0 ? (
              <>
  <AverageMonthlyData/>
  </>
            ) : (
              
        <div style={{marginTop:"60px"}}>
          <p className="text-center">No Vendors Found !! <Link to="/createVendor" className="text-danger">Click here</Link> to Create</p>
        </div>
            )
          )}
    </div>
          )
        }
